import {
  ANI_ROUTER,
  CLIENT,
  DATE_RANGE_ROUTER,
  DAY_OF_WEEK_ROUTER,
  DNIS_ROUTER,
  HUNT_GROUP,
  MATCH_START,
  NUMBER_PLAN,
  PLAY,
  PLUGIN,
  QUEUE,
  REMOTE,
  ROUTE_START,
  SAY,
  SCRIPT,
  SIP,
  SIP_GATEWAY,
  TEAM,
  TIME_RANGE_ROUTER,
  VOICEMAIL,
  ZONE_ROUTER,
} from "callable-data-objects";
import {
  SemanticCOLORS,
  SemanticICONS,
} from "semantic-ui-react/dist/commonjs/generic";

type WidgetProp = {
  type: string;
  icon: SemanticICONS;
  color: SemanticCOLORS;
  name: string;
};

export const widgets: WidgetProp[] = [
  {
    type: ROUTE_START,
    color: "green",
    icon: "arrow alternate circle right",
    name: "Inbound Flow",
  },
  {
    type: MATCH_START,
    color: "green",
    icon: "arrow alternate circle left",
    name: "Outbound Flow",
  },
  { type: ANI_ROUTER, color: "green", icon: "sliders", name: "ANI Router" },
  { type: DNIS_ROUTER, color: "green", icon: "sliders", name: "DNIS Router" },
  { type: ZONE_ROUTER, color: "green", icon: "sliders", name: "Region Router" },
  { type: NUMBER_PLAN, color: "green", icon: "sliders", name: "Number Plan" },
  {
    type: TIME_RANGE_ROUTER,
    color: "green",
    icon: "calendar alternate",
    name: "Time Range Router",
  },
  {
    type: DATE_RANGE_ROUTER,
    color: "green",
    icon: "calendar alternate",
    name: "Date Range Router",
  },
  {
    type: DAY_OF_WEEK_ROUTER,
    color: "green",
    icon: "calendar alternate",
    name: "Day Of Week Router",
  },
  { type: SCRIPT, color: "green", icon: "code", name: "Script" },
  { type: PLUGIN, color: "green", icon: "plug", name: "Plugin" },
  { type: PLAY, color: "purple", icon: "bullhorn", name: "Play" },
  { type: SAY, color: "purple", icon: "bullhorn", name: "Say" },
  { type: TEAM, color: "blue", icon: "user", name: "Teams Endpoint" },
  { type: REMOTE, color: "blue", icon: "phone", name: "Remote Endpoint" },
  { type: HUNT_GROUP, color: "blue", icon: "group", name: "Hunt Group" },
  { type: CLIENT, color: "blue", icon: "phone", name: "SIIP Client / Web RTC" },
  { type: SIP_GATEWAY, color: "blue", icon: "globe", name: "SIP Gateway" },
  { type: SIP, color: "blue", icon: "globe", name: "SIP Extension" },
  { type: QUEUE, color: "blue", icon: "list", name: "Queue" },
  { type: VOICEMAIL, color: "blue", icon: "globe", name: "Voicemail" },
  { type: "HANGUP", color: "red", icon: "stop", name: "Hangup" },
];

export const get = (key: string): WidgetProp => {
  console.log({ widget: key });
  const w = widgets.find((w) => w.type === key);
  if (w) return w;
  throw new Error("Cannot find widget");
};
